<template>
	<div class>
		<el-button type="primary" @click="useqqlogin">qq登录</el-button>
	</div>
</template>

<script>
	export default {
		name: "",
		data() {
			return {};
		},
		methods: {
			// qq登录
			useqqlogin() {
				QC.Login.showPopup({
					//打开QQ授权登录界面，授权成功后会重定向
					appId: "101516096",
					redirectURI: "http://192.168.2.138:8080/#/qq_login", //登录成功后会自动跳往该地址
				});
				// var state = this.$route.path;
				// var redirect_uri = encodeURIComponent(
				// 	"https://www.sz517.com/Request/qqCallBack"
				// );
				// window.open(
				// 	"https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101516096&state=" +
				// 		123 +
				// 		"&redirect_uri=" +
				// 		redirect_uri
				// );
			},

			getQQ() {
				// var redirect_uri = encodeURIComponent(
				// 	"https://www.sz517.com/Request/qqCallBack"
				// );
				// this.$axios
				// 	.get(
				// 		"https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101516096&state=" +
				// 			123 +
				// 			"&redirect_uri=" +
				// 			redirect_uri
				// 	)
				// 	.then((res) => {
				// 		var state = this.$route.path;
				// 		//console.log(res);
				// 	})
				// 	.catch((err) => {
				// 		//console.log(err);
				// 	});
			},
		},
		created() {},
		mounted() {
			QC.Login({
				btnId: "qq",
			});
		},
	};
</script>

<style scoped>
</style>
